import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/service/index'

import xdvideo from './xdvideo';

Vue.use(Vuex)

let pageMap = {
  Star: '名人堂',
  Store: '商城',
  Apply: '报名',
  Schedule: '赛程',
  Live: '直播',
  Teams: '战队',
  Quiz: '竞猜',
  DetailClan: '战队详情',
  DetailMembers: '队员详情'
}

export default new Vuex.Store({
  modules: {
      xdvideo,
  },
  state: {
    token: '',  // 用户token
    uid: '',
    scale: 1, // 压缩比例
    player: '',
    videoLink: '',
    liveInfo: {},
    navStatus: {},
    teamsInfo: [], // 队伍信息
    fullScreen: false, // 全屏
    schedule: [], // 赛程
    amount: 0, // 余额
    maxViewTime: 10,  // 最大观看时长
    userInfo: {
      amount: 0, // 余额
      loginReceive: '', // 每日登陆领取状态 receive received
      viewReceive: '', // 观看直播领取状态 receive received undone
      viewTime: 0 // 观看时长
    },
    isHintSchedule: false,  // 导航栏竞猜红点
    isHintLive: true, // 直播页实时竞猜红点
    clientSize: {}, // 屏幕尺寸
    config: {}, // 赛事中心静态数据, 配置: https://silent.xindong.com/pro/form/submit/NBvoEqSY1G4yx3zM
    subPage: '',
    seasonInfo: {},
    liveRoomList:[],  // 直播列表,默认四个，
    force : false,
    // 领取状态
    showLingqu: {
      quizHots: {
        quizTop: 0
      },
      taskHots:{
        shopTop:0
      }
    },
    dailyTasksList: [],
    // 功能拦截 - 设为true时，将隐藏送礼模块, 为1阶段
    isInterdict: false,
    // 控制弹窗显示
    popupStatus: {
      id: '',
      params: {}
    },
    // 商城商品列表
    mall: {
      goodsList: [],
      resident: []
    },
    // 控制报名
    registration: {
      switch: false, // 报名开关需配置在本地，依赖json会有延迟
      testOtherModule: true, // 测试其他模块
    },
  },
  mutations: {
    SET_UID(state, uid) {
      state.uid = uid
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_SCALE(state, scale) {
      state.scale = scale
    },
    SET_PLAYER(state, player) {
      state.player = player
    },
    SET_VIDEOLINK(state, link) {
      state.videoLink = link
    },
    SET_LIVEINFO(state, videoInfo) {
      state.liveInfo = videoInfo
    },
    SET_NAVSTATUS(state, status) {
      state.navStatus = status
    },
    SET_TEAMSINFO(state, teamsInfo) {
      state.teamsInfo = teamsInfo
    },
    SET_FULLSCREEN(state, bool) {
      state.fullScreen = bool
    },
    SET_SCHEDULE(state, schedule) {
      state.schedule = schedule
    },
    SET_AMOUNT(state, amount) {
      state.amount = amount
    },
    SET_USERINFO(state, info) {
      state.userInfo = info
    },
    SET_CLIENTSIZE(state, payload) {
      state.clientSize = payload
    },
		SET_INFO(state, payload) {
			state[payload.key] = payload.val
		},
    SET_PAGE(state, payload) {
      state.subPage = payload
    },
    SET_SEASONINFO(state, payload) {
      state.seasonInfo = payload;
    },
    SET_LIVEROOMLIST(state, list){
      // console.log('list',list);
      state.liveRoomList = list
    },
    // 领取状态
    SET_SHOWLINGQU(state, prompt){
      state.showLingqu = prompt
    },
    SET_DAILYTASKSLIST(state, data){
      // console.log('lis22t',data);
      state.dailyTasksList = data
    },
    SHOW_POPUP(state, payload){
      state.popupStatus = payload
    },
    HIDE_POPUP(state){
      state.popupStatus = {
        id: '',
        params: {}
      }
    },
    // 商城商品列表
    SET_GOODSLIST(state, payload){
      state.mall.goodsList = payload.goodsList
      state.mall.resident = payload.resident
    }
  },
  actions: {
    async reqTeamsList (context, data) {
      const teamsInfo = await api.reqTeamsList(data)
      context.commit('SET_TEAMSINFO', teamsInfo.data.teamLists)

      return teamsInfo;
    },
    async reqUserInfo ({commit, state},force) {
      if(!state.token) return;
      let response = await api.reqUserInfo({token: state.token,force});
      if (response.status == 200) {
        const info = response.data;
        commit('SET_USERINFO', {
          quizAmounts: info.quizRemainNum,
          matchAmounts: info.matchRemainNum,
          // loginReceive: loginReceive,
          // viewReceive: viewReceive,
          part2StartTime: info.part2StartTime,
          viewTime: info.viewTime,
          ...info
        })
        commit('SET_AMOUNT', info)
        if(info.uid) {
          commit('SET_UID', info.uid)
        }
      }else{
        alert(response.data)
      }
    },
    setPagePropertyEvent ({commit, state}, data) {
      let { page } = data;
      if(page) {
        commit('SET_PAGE', page);
      }
      
      if(typeof tapdb == 'undefined') return;

      tapdb.setPagePropertyEvent({
        '#tag': 'sausageMatch',
        '#page': state.subPage,
        '#user_id': state.uid
      });
      tapdb.trackEvent('切换页签', {
        '#name': pageMap[state.subPage] || state.subPage
      });
    },
    async reqMatchSimpleSeasons ({commit, state}) {
      if(!state.token) return;
      let response = await api.reqMatchSimpleSeasons({token: state.token});
      if (response.status == 200) {
        const s_list = response.data;
        // 竞猜信息默认第一个
        const info = s_list.find(item => item.status == 1) || {};
        commit('SET_SEASONINFO', info);
      }
    },
    // 获取红点状态 
    async reqRedDotState({commit, state}){
      if(!state.token) return;
      let response = await api.getRedDotState({token: state.token});
      if (response.status == 200) {
        const info = response.data;
        commit('SET_SHOWLINGQU', {
          quizHots: {
            quizTop: info.quizHots.quizTop
            },
          taskHots:{
            shopTop:info.taskHots.shopTop
          },
          ...info
        })
      }
    },
    // 获取商城商品列表
    async getGoodsList({commit, state}) {
      if (!state.token) return;
      let data = {
        token: state.token
      }
      let response = await api.reqGoodsList(data)
      if (response.status == 200) {
        // console.log('response', response.data)
        commit('SET_GOODSLIST', {
          goodsList: response.data.dailyGoods,
          resident: response.data.cumulGoods
        })
      }
    },
  }
  
})